import { jwtDecode } from "jwt-decode";
import { ACCESS_TOKEN, MANAGER_CLIENT_ACCESS_TOKEN } from "../constants/PreferenceKeys";


export const isManagerCreatedToken = (token) => {
    if(token){
        const decodedPayload = jwtDecode(token);
        if(decodedPayload.isManager === "MANAGER"){
            return true;
        }
    }
    return false;
}

export const whichTokenToUse = () => {
    // Manager tab — sessionStorage has the flag
    if (sessionStorage.getItem("IS_MANAGER_IMPERSONATION") === "true") {
        if (sessionStorage.getItem(MANAGER_CLIENT_ACCESS_TOKEN) && 
            localStorage.getItem(MANAGER_CLIENT_ACCESS_TOKEN)) {
            return MANAGER_CLIENT_ACCESS_TOKEN;
        }
    }

    // Normal client
    if (localStorage.getItem(ACCESS_TOKEN) && 
        !isManagerCreatedToken(localStorage.getItem(ACCESS_TOKEN))) {
        return ACCESS_TOKEN;
    }

    return ACCESS_TOKEN;
};

export const isManagerView = () => {
    return isManagerCreatedToken(localStorage.getItem(whichTokenToUse()));
}
